export default {
  siteOwners: []
}
